import { useRachelPresentation } from '../../../hooks/useRachelPresentation';
import { ProductCardsBlock } from './productCardsBlock.types';
import { PRODUCT_CARDS_LIMIT } from './productCardsBlock.utils';

export const useProductCardsBlock = (block: ProductCardsBlock) => {
  const { isMaximized } = useRachelPresentation();

  return {
    products: block.products.slice(0, PRODUCT_CARDS_LIMIT),
    isCarousel: isMaximized,
  };
};
